import React, { useState } from "react";
import Select from "../UniversalComponents/SelectComponent";
import Button from "../UniversalComponents/DefaultButton";
import "react-datepicker/dist/react-datepicker.css";
import Input from "../UniversalComponents/InputComponent";
import LayoutHOC from "../LayoutHOC";
import VendorHeaderHoc from "./VendorHeaderHoc";

const filterData = [
  { value: "1", label: "Filter" },
  { value: "2", label: "option1" },
  { value: "3", label: "option2" },
  { value: "4", label: "option3" },
];
const paymentAccounts = [
  { value: "Choose a vendor", label: "Choose a vendor" },
  { value: "Bank Account 1", label: "Bank Account 1" },
  { value: "Credit Card 1", label: "Credit Card 1" },
  { value: "PayPal", label: "PayPal" },
];

const PayBills = () => {
  const [paymentAccount, setPaymentAccount] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [InputValue, setInputValue] = useState("");

  const handlePaymentAccountChange = (e) => {
    setPaymentAccount(e.target.value);
  };

  const handlePaymentDateChange = (e) => {
    setPaymentDate(e.target.value);
  };

  const handleFilterChange = (e) => {
    setFilterValue(e.target.value);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div className="mx-10">
      <div className="flex gap-3">
        <div className="bg-white border border-[#D6D3D3] px-4 w-[90%] flex  rounded-md">
          <div className="space-x-2 flex  justify-between  w-[50%] mt-8 gap-2 ">
            <div className="w-full space-x-2 mb-7 ml-5 justify-center  ">
              <label htmlFor="paymentAccount" className="block text-gray-700 text-#434852 text-sm font-medium ml-2  ">
                Payment account
              </label>

              <Select
                id="paymentAccount"
                value={paymentAccount}
                onChange={handlePaymentAccountChange}
                style={{ width: "100%", height: "35px", padding: "5px" }}
                options={paymentAccounts}
              />
            </div>
            <div className=" justify-between items-center w-full ">
              <label htmlFor="paymentAccount" className="block text-gray-700 text-#434852  text-sm font-medium">
                Bill Date
              </label>
              <input className="rounded h-[35px] w-[100%] border-[#DFE2E5] text-[#AFAFAF] " type="date" />
            </div>
          </div>
        </div>
        <div className="border-[#DFE2E5] bg-white border rounded-md items-center px-8 py-14 ">
          <div className="flex flex-col bg-[#0093C1] gap-1 p-4 items-center ">
            <span className="text-[#FFFFFF] text-16 font-400 text-nowrap">Available Amount</span>
            <span className="text-[#FFFFFF] text-30">$ 0.00</span>
          </div>
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-3 mb-3 text-#848687 rounded-sm">
        <div
        // className="flex justify-end-3 mt-3"
        >
          <Select
            // id="filter
            placeholder="filter"
            style={{ width: "100px", height: "35px", padding: "5px" }}
            value={filterValue}
            onChange={handleFilterChange}
            options={filterData}
          />
        </div>

        <div className="">
          <Input
            style={{ width: "150px", height: "35px", padding: "5px" }}
            value={InputValue}
            placeholder="Last  12 Months"
            onChange={handleInputChange}
            className="  border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 "
          />
        </div>
        <div className="w-4 h-4 mr-3 text-#848687">
          <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
            <path
              d="M20.7403 15.1438L19.3245 14.0656C19.3424 13.8994 19.3578 13.705 19.3578 13.4994C19.3578 13.2938 19.3431 13.0994 19.3245 12.9331L20.7416 11.8544C21.0048 11.6519 21.0767 11.2925 20.9091 10.9932L19.4368 8.5125C19.2795 8.23251 18.9349 8.08875 18.5851 8.21438L16.9144 8.86749C16.5942 8.64249 16.2585 8.4525 15.9113 8.30063L15.6571 6.57501C15.6154 6.2475 15.3227 6 14.9768 6H12.0244C11.6784 6 11.3864 6.2475 11.3453 6.57L11.0905 8.30188C10.7542 8.44939 10.4237 8.63689 10.0893 8.86875L8.41414 8.21376C8.10026 8.09563 7.72479 8.22812 7.56883 8.50688L6.09458 10.9906C5.92066 11.2769 5.99253 11.6488 6.26146 11.8563L7.67732 12.9344C7.65484 13.145 7.64395 13.3281 7.64395 13.5C7.64395 13.6719 7.65487 13.855 7.67732 14.0663L6.26017 15.145C5.99701 15.3481 5.92577 15.7075 6.09329 16.0063L7.56564 18.4869C7.7229 18.7663 8.06434 18.9113 8.41733 18.785L10.088 18.1319C10.4076 18.3563 10.7433 18.5463 11.0905 18.6988L11.3447 20.4238C11.3864 20.7525 11.6784 21 12.025 21H14.9774C15.3234 21 15.616 20.7525 15.6571 20.43L15.9119 18.6988C16.2482 18.5506 16.5781 18.3637 16.9131 18.1312L18.5883 18.7862C18.6692 18.8169 18.7533 18.8325 18.8399 18.8325C19.0889 18.8325 19.318 18.7 19.4336 18.4937L20.9123 16C21.0767 15.7075 21.0048 15.3481 20.7403 15.1438ZM13.5006 16C12.0847 16 10.9333 14.8787 10.9333 13.5C10.9333 12.1213 12.0847 11 13.5006 11C14.9164 11 16.0679 12.1213 16.0679 13.5C16.0679 14.8787 14.9164 16 13.5006 16Z"
              fill="#B4C0C8"
            />
          </svg>
        </div>
      </div>
      <div className="bg-white border border-[#D6D3D3] px-4 h-40 mt-4 flex "></div>
      <div className=" flex justify-end">
        <div className=" flex justify items-end space-x-2 mt-4  ">
          <div className="w-[284px] bg-[#D4EAEE] border-[#BEDADF] flex justify-between text-16 text-[#535252] items-center rounded-5px pb-3 mt-2">
            <span className="font-400">Total</span>
            <span className="font-600 ">$ 0.00</span>
          </div>
          <Button type="primary" style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          {/* <Button type="primary" style={{ color: "#535252" }}>
            SAVE
          </Button> */}
          <Button type="secondary" style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LayoutHOC(VendorHeaderHoc(PayBills));
